export default "__VITE_ASSET__cf48d120__"